import React from "react";
const BatchSelectionContext = /*#__PURE__*/React.createContext({
  batchSelectionDisabled: false
});
export default BatchSelectionContext;